import React from 'react';
import { Button } from 'shared/components';
import PropTypes from 'prop-types';

import './SwitchButton.scss';

const SwitchButton = (props) => (
  <div className="switch-button-container">
    <div className="switch-button buttons-container">
      <Button
        type={props.leftActive ? 'btn-primary' : 'btn-primary btn-outline'}
        className="w-50 m-0 btn-left btn-selector"
        text={props.leftLabel}
        onClick={props.switchButton}
      />
      <Button
        type={!props.leftActive ? 'btn-primary' : 'btn-primary btn-outline'}
        className="w-50 m-0 btn-right btn-selector"
        onClick={props.switchButton}
        text={props.rightLabel}
      />
    </div>
    {props.description && <span>{props.description}</span>}
  </div>
);

export default SwitchButton;

SwitchButton.propTypes = {
  leftActive: PropTypes.bool,
  leftLabel: PropTypes.string.isRequired,
  rightLabel: PropTypes.string.isRequired,
  switchButton: PropTypes.func.isRequired,
};

SwitchButton.defaultProps = {
  leftActive: true,
};
